import React, { FunctionComponent } from 'react'
import { Callback } from '../../../utils/types'
import { TradelineSelectionCard } from './tradelineSelectionCard'
import { displayDollars } from '../../../helpers/displayFormatHelper'

export interface Props {
  data: any
  selected?: boolean
  onSelect: Callback
}

const InfoRow = ({ title, value }) => {
  return (
    <div className="tradeline-info__row">
      <div className="tradeline-info__title">{title}</div>
      <div className="tradeline-info__value">{value}</div>
    </div>
  )
}

const TradelineOptionCard: FunctionComponent<Props> = ({
  data,
  selected,
  onSelect,
}) => {
  const {
    amount,
    institution,
    payment,
    balance,
    term,
    remaining,
    apr,
    tradeline_index,
  } = data

  const formatMonths = (months) => {
    return `${months} months`
  }
  const formatPct = (value) => {
    return `${Number(value).toFixed(4)}%`
  }
  const onClickCard = () => {
    onSelect(data)
  }
  const gridClassName = selected
    ? 'tradeline-selection-card__selected'
    : undefined

  return (
    <div onClick={onClickCard} data-testid={tradeline_index}>
      <TradelineSelectionCard
        title={institution}
        selected
        gridClass={gridClassName}
      >
        <InfoRow title={'Monthly payment'} value={displayDollars(payment)} />
        <InfoRow title={'Remaining balance'} value={displayDollars(balance)} />
        <InfoRow title={'Principal balance'} value={displayDollars(amount)} />
        <InfoRow title={'Loan term'} value={formatMonths(term)} />
        <InfoRow
          title={'Estimated term remaining'}
          value={formatMonths(remaining)}
        />
        <InfoRow
          title={'Estimated Annual Percentage Rate (APR)'}
          value={formatPct(apr)}
        />
      </TradelineSelectionCard>
    </div>
  )
}

TradelineOptionCard.displayName = 'TradelineOptionCard'

export default TradelineOptionCard
